import React from 'react';
import PDFRepositoryWidgetBuilder from './PDFRepositoryWidgetBuilder';
import PDFRepositoryWidgetRenderer from './PDFRepositoryWidgetRenderer';
import Preview from './Preview';
import type { WidgetDefinition } from '../../../registry';
import type { PDFRepositoryWidgetConfig } from './types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolderOpen } from '@fortawesome/free-solid-svg-icons';

export { default as PDFRepositoryWidgetBuilder } from './PDFRepositoryWidgetBuilder';
export { default as PDFRepositoryWidgetRenderer } from './PDFRepositoryWidgetRenderer';
export * from './types';

export const definition: WidgetDefinition = {
  type: 'pdf_repository',
  meta: {
    label: 'PDF Repository',
    icon: React.createElement(FontAwesomeIcon, { icon: faFolderOpen }),
    description: 'Store and browse tagged PDF documents',
    isSystem: true,
    isCreatable: false,
    shareable: true,
    dataFlow: 'both',
  },
  defaultSize: { w: 8, h: 6, minW: 6, minH: 5 },
  defaultConfig: () => ({
    allowUpload: true,
    allowDelete: true,
    allowTagging: true,
    gridView: true,
    thumbnailSize: 'medium',
  } as PDFRepositoryWidgetConfig),
  Builder: PDFRepositoryWidgetBuilder,
  Renderer: PDFRepositoryWidgetRenderer,
  Preview,
};
